<template>
  <v-app-bar
    id="menu"
    class="elevation-toolbar"
    flat
    app
    color="#F6F3F0"
    style="
      border: 0px;
      border-bottom: 1px solid rgba(16, 42, 98, 0.1);
    "
    height="100"
  >
    <template>
      <img
        height="50"
        @click="gotoHome()"
        style="z-index: 1"
        class="hover-underline hidden-sm-and-down"
        :src="require('@/../public/images/bsp-logo-two.png').default"
      />

      <v-btn
        text
        height="100%"
        :active-class="!menu2 ? 'toolbar-items-active-notification ' : ''"
        class="toolbarPurple hidden-md-and-up"
        icon
      >
        <v-icon size="25" color="defaultColor">mdi-menu</v-icon>
      </v-btn>
      <v-spacer />
    </template>

    <!-- Feed Share Dialog -->
    <create-post-dialog
      :visible="$store.state.createDialogStatus"
      @close="$store.state.createDialogStatus = false"
    />

    <!-- Request Live Stream Dialog -->
    <request-live-stream-dialog 
      :visible="requestLiveStreamDialog"
      @close="requestLiveStreamDialog = false"
      @successRequest="successRequestDialog = true"
    />

    <template>
      <v-toolbar-items
        style="position: absolute; text-align: center; width: 100%"
        class="font-brandon-grotesque title hidden-sm-and-down"
      >
        <div style="margin: auto">
          <!-- Home -->
          <v-btn
            id="textButton"
            text
            class="text-capitalize toolbarText"
            :ripple="false"
            to="/home"
            active-class="activeMenu"
            height="100"
            >{{ $t("menu.social") }}</v-btn
          >

          <!-- Interaction -->
          <v-btn
            id="textButton"
            class="american_river--text text-capitalize toolbarText"
            active-class="activeMenu"
            height="100"
            :ripple="false"
            to="/interaction"
            text
            >{{ $t("menu.interaction") }}</v-btn
          >

          <!-- Create Post dialog -->
          <v-menu offset-y :nudge-left="user.Type.toLowerCase() != 'standart' ? '30' : '60'" nudge-bottom="5">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="pt-0 elevation-0 mx-2 text-none createButton"
                v-bind="attrs"
                v-on="on"
                :ripple="false"
              >
                <v-icon size="20" color="defaultColor">mdi-plus</v-icon>
              </v-btn>
            </template>
            <v-list dense>
              <template>
                <v-list-item
                  class="py-2 font-weight-medium defaultColor--text"
                  style="font-size: 13px"
                  link
                  @click="$store.state.createDialogStatus = true"
                >
                  <v-list-item-content class="justify-center">
                    {{ $t("menu.createPost") }}
                  </v-list-item-content>
                </v-list-item>
                <v-divider />
                <v-list-item
                  class="py-2 font-weight-medium defaultColor--text"
                  style="font-size: 13px"
                  link
                  @click="liveStreamOperation"
                >
                  <v-list-item-content>
                    {{ user.Type.toLowerCase() != 'standart' ? $t("menu.createLive") : $t("menu.createRequestLive")}}
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-list>
          </v-menu>

          <!-- Academy -->
          <v-btn
            id="textButton"
            class="american_river--text text-capitalize toolbarText"
            active-class="activeMenu"
            height="100"
            :ripple="false"
            to="/academy"
            text
            >{{ $t("menu.academy") }}</v-btn
          >

          <!-- Social -->
          <v-btn
            id="textButton"
            class="text-capitalize toolbarText"
            active-class="activeMenu"
            height="100"
            :ripple="false"
            to="/batNews"
            text
            >{{ $t("menu.batNews") }}</v-btn
          >
        </div>
      </v-toolbar-items>
    </template>

    <v-toolbar-items>
      <!-- Search -->
      <v-btn
        to="/searchHome"
        class="flat hidden-sm-and-down ml-0 mr-0 ma-0 pa-0 pl-0 pr-0"
        :ripple="false"
        active-class="activeMenu"
        icon
      >
        <v-icon color="defaultColor" size="27">mdi-magnify</v-icon>
      </v-btn>

      <!-- Message -->
      <v-btn
        text
        :ripple="false"
        class="ml-0 toolbarPurple hidden-sm-and-down"
        icon
        color="defaultColor"
        active-class="activeMenu"
        to="/chat"
      >
        <v-badge
          v-if="$store.state.unreadMessageCount != 0"
          bordered
          overlap
          :content="$store.state.unreadMessageCount"
        >
          <v-icon size="25" color="defaultColor">mdi-email</v-icon>
        </v-badge>
        <v-icon v-else size="25" color="defaultColor">mdi-email</v-icon>
      </v-btn>

      <!-- Notification -->

      <v-btn
        text
        :ripple="false"
        active-class="activeMenu"
        class="ml-0 toolbarPurple hidden-sm-and-down"
        icon
        color="defaultColor"
        to="/notifications"
      >
        <v-badge
          v-if="$store.state.totalUnSeenNotification != 0"
          bordered
          overlap
          :content="$store.state.totalUnSeenNotification"
        >
          <v-icon size="25" color="defaultColor">mdi-bell</v-icon>
        </v-badge>
        <v-icon v-else size="25" color="defaultColor">mdi-bell</v-icon>
      </v-btn>

      <!-- Profile -->
      <v-menu
        class="elevation-0 ml-10"
        :close-on-content-click="true"
        :nudge-width="150"
        nudge-bottom="65"
        nudge-right="-150"
        transition="slide-y-transition"
        origin="top right"
        open-on-hover
        attach
        z-index="11"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn class="pa-0" v-bind="attrs" :ripple="false" v-on="on" text>
            <v-avatar size="55">
              <div class="borderAvatarMom">
                <div class="module">
                  <v-avatar size="55">
                    <v-img :src="user.Avatar" />
                  </v-avatar>
                </div>
              </div>
            </v-avatar>
          </v-btn>
        </template>
        <toolbar-expand-avatar />
      </v-menu>
    </v-toolbar-items>
  </v-app-bar>
</template>

<script>
import ToolbarExpandAvatar from "./ToolbarExpandAvatar.vue";
import ToolbarExpandCreateContent from "./ToolbarExpandCreateContent.vue";
import CreatePostDialog from "../Posts/CreatePostDialog.vue";
import RequestLiveStreamDialog from "../LiveStream/RequestLiveStreamDialog.vue";

import { mapState } from "vuex";

export default {
  components: {
    ToolbarExpandAvatar,
    ToolbarExpandCreateContent,
    CreatePostDialog,
    RequestLiveStreamDialog,
  },

  data() {
    return {
      expand: false,
      //searchInput: "",
      menu: false,
      menu2: false,

      createDialogStatus: false,

      requestLiveStreamDialog: false,
    };
  },

  watch: {},

  mounted() {},

  methods: {
    gotoHome() {
      console.log("home");
      this.$router.push("/login");
    },

    liveStreamOperation(){
      if (this.user.Type.toLowerCase() != 'standart') {
            //Admin
            //Canlı Yayın Başlatma İşlemi
            //TODO: Admin için canlı yayın isteği oluşturulacak
            this.$store.state.liveStreamStartInfoDialogShow = true
        } else {
           //Standart kullanıcı
           //Canlı Yayın isteğinde bulunacak
          this.requestLiveStreamDialog = true
        }
    }
  },

  computed: {
    ...mapState(["user"]),
  },
};
</script>

<style>
.v-toolbar__content .v-btn__content {
  font-size: 16px;
  letter-spacing: 0.7px;
}

#menu .v-btn::before {
  display: none;
}

#menu .v-btn i:hover {
  transform: scale(1.15);
}

#textButton .v-btn__content:hover {
  color: #2d3436 !important;
}

.toolbar-items-active-notification::before {
  color: transparent;
}

.dialog-offset-top {
  top: 64px;
}

.dialogDiagnoButtonHover .v-card--hover:hover {
  background-color: rgb(123, 35, 216) !important;
  -webkit-box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0),
    0px 0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px 0px rgba(0, 0, 0, 0);
  box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px 0px rgba(0, 0, 0, 0),
    0px 0px 0px 0px rgba(0, 0, 0, 0);
}

.dialogVideoButtonHover .v-card--hover:hover {
  background-color: rgb(2, 142, 212) !important;
  -webkit-box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0),
    0px 0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px 0px rgba(0, 0, 0, 0);
  box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px 0px rgba(0, 0, 0, 0),
    0px 0px 0px 0px rgba(0, 0, 0, 0);
}

.dialogArticleButtonHover .v-card--hover:hover {
  background-color: #414141 !important;
  -webkit-box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0),
    0px 0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px 0px rgba(0, 0, 0, 0);
  box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px 0px rgba(0, 0, 0, 0),
    0px 0px 0px 0px rgba(0, 0, 0, 0);
}

.toolbarPurple {
  /* color: black !important;
  font-weight: 700; */
}

.createButton {
  background: rgba(255, 255, 255, 1);
  /*background: linear-gradient(
    00deg,
    rgba(162, 155, 254, 1) 0%,
    rgba(255, 118, 117, 1) 100%
  );*/
  border: 1.5px solid #102a62;
  border-radius: 50% !important;
  max-height: 66px !important;
  min-height: 66px !important;
  max-width: 66px !important;
  min-width: 66px !important;
}
</style>
